import Rollbar from 'rollbar';

import { getUser } from 'actions/asyncActions';

export default function initRollbar(store) {
    window._rollbarConfig = {
        accessToken: '25368a3eed8146aca2bb24ba3e028bcc107e0eadf1d7c260770f8c16c9409b03ba07f12df646200f64cf2ed77ed72d18',
        captureUncaught: true,
        payload: {
            environment: window.location.host,
            client: {
                javascript: {
                    source_map_enabled: true,
                    code_version: process.env.REACT_APP_BUILD_NUMBER || 0,
                    guest_uncaught_frames: true
                }
            }
        },
        ignoredMessages: [
            'ResizeObserver loop limit exceeded.',
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
            'ResizeObserver loop completed with undelivered notifications',
            'Script error.',
            'Script error'
        ],
        transform: payload => {
            const user = getUser.selectData(store.getState());
            payload.person = {
                id: user.id,
                username: `${user.lastName || ''} ${user.firstName || ''} ${user.middleName || ''}`,
                email: user.email
            };
        }
    };

    window._version = {
        version: process.env.REACT_APP_BUILD_NUMBER || 0,
        date: process.env.REACT_APP_DATE
    };

    Rollbar.init(window._rollbarConfig);
}

export const isRollbarInit = process.env.NODE_ENV === 'production';

export const pushRollbarError = error => {
    if (isRollbarInit) {
        if (!error.origin) {
            Rollbar.error(error.message, error);
        }

        if (/5[01][0-9]/.test(error.status)) {
            Rollbar.error('Server Error', error);
        }
    }
};
